export function getCountryCode() {
  const domain = window.location.hostname;
  let countrycode = "cl";
  const countries: any = {
    cl: [
      "cl.transferencia-simulador.local",
      "cl.transferencia-simulador.autofact.qa",
      "transferencia-simulador.staging.autofact.cl",
      "transferencia-simulador.autofact.cl"
    ],
  };

  Object.keys(countries).forEach(country => {
    if (countries[country].includes(domain)) {
      countrycode = country;
    }
  });

  return countrycode;
}
